<template>
  <div class="header layout-padding" id="main-header">
    <div class="header-inner" ref="headerInner" :class="{ 'border-0': showSearch }">
      <router-link to="/">
        <img src="/static/images/new_logo.png" alt="" style="width: 150px;">
        <!-- <div style="background: url(/static/images/new_logo.png);" ></div> -->
      </router-link>
      <div class="w-full ">
        <ul class="flex m-0 p-0 items-center gap-6 justify-center">
          <router-link to="/" class="ml-auto">
            <li class="cursor-pointer menu-item   hidden xl:flex">
              {{ content.home }}
            </li>
          </router-link>
          <router-link to="/about">
            <li class="cursor-pointer menu-item  hidden xl:flex">
              {{ content.whoWeAre }}
            </li>
          </router-link>

          <div class="relative" @mouseover="showDropDown" @mouseleave="hideDropDown">
            <router-link id="dropDown" to="/services/1">
              <li class="cursor-pointer menu-item  hidden xl:flex">
                {{ content.products }}

              </li>
            </router-link>
            <Transition>
              <div id="dropDownItems" v-show="showDropdown"
                class="  absolute  top-22 -ml-10 w-48  min-w-max rounded-2xl  shadow-lg"
                style="backdrop-filter: blur(14px);background: rgba(0,0,0,0.5);">
                <div class="m-2">

                  <ul>
                
                    <li class="w-full p-2 text-white " id="ProductList" @click="selectProduct(product.title)"
                      v-for="product in products" :key="product.id">
                      <span class="paragraph">{{
                        product?.title.charAt(0).toUpperCase() +
                        product?.title.slice(1)
                      }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </Transition>
          </div>
          <router-link to="/operate">
            <li class="cursor-pointer menu-item  hidden xl:flex">
              {{ content.whereWeOperate }}
            </li>
          </router-link>
          <router-link to="/contact">
            <li class="cursor-pointer menu-item  hidden xl:flex">
              {{ content.contactUs }}
            </li>
          </router-link>

          <li class="flex xl:hidden" @click="showMobileMenu = !showMobileMenu">
            <div class="hamburger-icon">
              <span class="line" :class="{ cross: showMobileMenu }"></span>
              <span class="line" :class="{ cross: showMobileMenu }"></span>
              <span class="line" :class="{ cross: showMobileMenu }"></span>
            </div>
          </li>
        </ul>
      </div>
    </div>

  </div>
  <div class="mobileMenu" style="height: 100vh;" :class="{ 'show-mobile-menu': showMobileMenu }">
    <ul class="w-full pt-32 pb-20 flex flex-col items-center justify-center">
      <router-link class="" to="/">
        <li @click="showMobileMenu = !showMobileMenu"
          class="text-3xl cursor-pointer font-bold text-white mobile-menu-item">
          {{ content.home }}
        </li>
      </router-link>
      <router-link class="" to="/about">
        <li @click="showMobileMenu = !showMobileMenu"
          class="text-3xl cursor-pointer font-bold text-white mobile-menu-item">
          {{ content.whoWeAre }}
        </li>
      </router-link>
      <router-link class="" to="/operate">
        <li @click="showMobileMenu = !showMobileMenu"
          class="text-3xl cursor-pointer font-bold text-white mobile-menu-item">
          {{ content.whereWeOperate }}
        </li>
      </router-link>
      <router-link class="" to="/contact">
        <li @click="showMobileMenu = !showMobileMenu"
          class="text-3xl cursor-pointer font-bold text-white mobile-menu-item">
          {{ content.contactUs }}
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showSearch: false,
      showMobileMenu: false,
      keyword: "",
      showDropdown: false,
    };
  },

  computed: {
    allData() {
      let about = this.$store.getters["whoWeAre/whoWeAre"];
      let services = this.$store.getters["services/services"];
      let operations = this.$store.getters["operations/operations"];
      return [about, services, operations];
    },
    products() {
      return this.$store.getters["products/products"];
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    showMobileMenu() {
      if (this.showMobileMenu == true) {
        let header = this.$refs.headerInner;
        header.classList.add("border-0");
        document.body.classList.add("overflow-hidden");
      }
      if (this.showMobileMenu == false) {
        let header = this.$refs.headerInner;
        header.classList.remove("border-0");
        document.body.classList.remove("overflow-hidden");
      }
    },
    showSearch() {
      if (this.showSearch) {
        document
          .getElementById("main-header")
          .classList.add("header-height-search");
      } else if (!this.showSearch) {
        document
          .getElementById("main-header")
          .classList.remove("header-height-search");
      }
    },
  },
  methods: {
    async loadData() {
      await this.$store.dispatch("products/getProducts");
      await this.$store.dispatch("productType/getProductType");
    },
    gotoSearch(event) {
      if (event.key === "Enter" || event.keyCode === 13) {
        this.startSearching();
      }
    },
    startSearching() {
      this.$router.push({ path: "/search", query: { keyword: this.keyword } });
      this.showSearch = false;
    },

    selectProduct(productTitle) {
      this.$router.push({
        name: "ProductType",
        params: { service: 1, title: productTitle },
      });
    },
    showDropDown() {
      this.showDropdown = true;
    },
    hideDropDown() {
      this.showDropdown = false;
    },
  },

  inject: ["content"],
};
</script>

<style>
#ProductList {
  cursor: pointer;
  /* border-bottom: 1px solid gray; */
  transition: transform 0.3s ease-in-out;
}
#productList {
  letter-spacing: 3rem !important;
}

#ProductList:hover {
  /* cursor: pointer; */
  /* border-bottom: 1px solid #0e273d; */
  transition: transform 0.3s ease-in-out;
  background-color: #fdfdfd;
  color: black;
  border-radius: 15px;
  /* scale: 1.02; */
}

#ProductList:last-child {
  border: none;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease-in;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
